// https://app.growthbook.io/features/bogo_offer
export const BOGO_OFFER_FLAG_NAME = 'bogo_offer'

// https://app.growthbook.io/features/bogo_sponsored_gift
export const BOGO_SPONSORED_GIFT = 'bogo_sponsored_gift'
